module.exports = __webpack_public_path__ + "static/differences-99b45c52281dabd5b5c1682426e42b6f.jpeg";